module.exports = __webpack_public_path__ + "media/brands/boatian-41746959.png";